<template>
  <div>
    <Header></Header>
    <div class="container posts-container">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { mapGetters } from "vuex";

// import Inputs from "@/components/basic/Input.vue";

export default {
  name: "Posts",
  components: {
    Header,
    Footer
  },
  methods: {
    bg: function(url) {
      return `background:url(${url});`;
    }
  },
  mounted() {
    this.$store.dispatch("events/get_event", this.$route.params.eventId);
    this.$store.dispatch("posts/load_posts", {
      event_id: this.$route.params.eventId,
      page: 1
    });
  },
  computed: {
    ...mapGetters({
      event: "events/get_current",
      Posts: "posts/get_posts"
    })
  }
};
</script>

<style lang="scss" scoped>
.posts-container {
  padding-top: 32px;
  padding-bottom: 64px;
  h1 {
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 56px;
  }
}
</style>